import { useEffect, useMemo, useRef } from "react";
import { useAppSelector } from "../../Store";
import { allMessagesStore } from "../../Store/Slices/socket/AllMessagesSlice";
import { botInfoStore } from "../../Store/Slices/socket/BotInfoSlice";
import { useBotConfigStore } from "../../Store/Slices/ChatbotSlices/BotConfigSlice";
import { HostWindowCommService } from "../../Services/IframeHostService/HostWindowCommService";
import { OEvents } from "../../Services/IframeHostService/models";

// Notification.requestPermission()/new Notification() are unconditionally
// blocked in cross-origin iframes (Chrome M60+, no `allow`/Permissions-Policy
// override exists for this — unlike camera/microphone/geolocation). The
// widget always runs inside one in production, so both calls have to happen
// in the host page's own script (geta-tracking-scripts' loader) instead —
// this hook only decides *when* to ask for a notification, via postMessage.
const usePendingChatNotification = () => {
  const { typingStatus } = useAppSelector(allMessagesStore);
  const { chatOpened } = useAppSelector(botInfoStore);
  const { botConfig } = useAppSelector(useBotConfigStore);

  const typingStatusRef = useRef(typingStatus);
  const chatOpenedRef = useRef(chatOpened);
  const botNameRef = useRef(botConfig?.chatbot?.name);

  typingStatusRef.current = typingStatus;
  chatOpenedRef.current = chatOpened;
  botNameRef.current = botConfig?.chatbot?.name;

  const commService = useMemo(() => HostWindowCommService.getInstance(), []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (
        document.hidden &&
        chatOpenedRef.current &&
        typingStatusRef.current
      ) {
        commService.postMessage({
          event_type: OEvents.CHATBOT_SHOW_NOTIFICATION,
          data: {
            title: botNameRef.current || "Geta Chat",
            body: "Your conversation is waiting.",
          },
        });
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [commService]);
};

export default usePendingChatNotification;
